import { render } from "./GridBanner.vue?vue&type=template&id=2e073dc0"
import script from "./GridBanner.vue?vue&type=script&lang=js"
export * from "./GridBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__